import { render } from "./nav-title.vue?vue&type=template&id=99774ac4&scoped=true"
import script from "./nav-title.vue?vue&type=script&lang=ts"
export * from "./nav-title.vue?vue&type=script&lang=ts"

import "./nav-title.vue?vue&type=style&index=0&id=99774ac4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-99774ac4"

export default script